/* eslint-disable */
// @ts-nocheck

import { triggerDestinationSlideAnimations } from './trigger-destination-slide-animations';

// Scripts used for slider modules.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
(function ($) {
  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_slider_modules = function () {
      const isBuilder = 'object' === typeof window.ET_Builder;
      const $et_pb_slider = $('.et_pb_slider');
      const $et_window = $(window);
      const sliderBottomControlsStyleId = 'et-pb-slider-bottom-controls-style';
      let hasSliderBottomControlsStyles = false;

      function et_ensure_slider_bottom_controls_styles() {
        if (hasSliderBottomControlsStyles) {
          return;
        }

        if (document.getElementById(sliderBottomControlsStyleId)) {
          hasSliderBottomControlsStyles = true;
          return;
        }

        const style = document.createElement('style');
        style.id = sliderBottomControlsStyleId;
        style.textContent = `
          .et_pb_slider .et-pb-slider-bottom-controls {
            position: absolute;
            left: 24px;
            right: 24px;
            bottom: 24px;
            display: flex;
            align-items: center;
            gap: 16px;
            width: auto;
            z-index: 12;
            color: #ffffff;
            pointer-events: none;
          }

          .et_pb_slider .et-pb-slider-bottom-controls .et-pb-slider-bottom-controls-counter,
          .et_pb_slider .et-pb-slider-bottom-controls .et-pb-slider-bottom-controls-swipe {
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0.08em;
            line-height: 1;
            text-transform: uppercase;
            white-space: nowrap;
          }

          .et_pb_slider .et-pb-slider-bottom-controls .et-pb-slider-bottom-controls-progress {
            display: flex;
            flex: 1 1 auto;
            align-items: center;
            gap: 8px;
            pointer-events: auto;
          }

          .et_pb_slider .et-pb-slider-bottom-controls .et-pb-slider-bottom-controls-progress a {
            display: block;
            flex: 1 1 0%;
            width: auto;
            height: 2px;
            margin: 0;
            border-radius: 999px;
            background-color: rgba(255, 255, 255, 0.35);
            opacity: 1;
            text-indent: -9999px;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0;
            line-height: 0;
            pointer-events: auto;
          }

          .et_pb_slider .et-pb-slider-bottom-controls .et-pb-slider-bottom-controls-progress a.et-pb-active-control {
            background-color: #ffffff;
            opacity: 1;
          }
        `;

        document.head.appendChild(style);
        hasSliderBottomControlsStyles = true;
      }

      jQuery.fn.closest_descendent = function (selector) {
        let $found;
        let $current_children = this.children();

        while ($current_children.length) {
          $found = $current_children.filter(selector);
          if ($found.length) {
            break;
          }
          $current_children = $current_children.children();
        }

        return $found;
      };

      // Coerce user-controlled values to plain text so later DOM insertion cannot treat them as HTML.
      function et_as_plain_text(value) {
        if (null === value || 'undefined' === typeof value) {
          return '';
        }

        return document.createTextNode(String(value)).nodeValue || '';
      }

      // Read a data-* attribute as text-safe content before it is assigned to the swipe label.
      function et_get_plain_text_attr($element, attr_name) {
        const raw_value = $element.attr(attr_name);

        if ('undefined' === typeof raw_value || '' === raw_value) {
          return '';
        }

        return et_as_plain_text(raw_value);
      }

      $.et_pb_simple_slider = function (el, options) {
        const settings = $.extend(
          {
            slide: '.et-slide', // slide class
            arrows: '.et-pb-slider-arrows', // arrows container class
            prev_arrow: '.et-pb-arrow-prev', // left arrow class
            next_arrow: '.et-pb-arrow-next', // right arrow class
            controls: '.et-pb-controllers a', // control selector
            carousel_controls: '.et_pb_carousel_item', // carousel control selector
            control_active_class: 'et-pb-active-control', // active control class name
            previous_text: 'undefined' !== typeof et_pb_custom ? et_pb_custom.previous : '', // previous arrow text
            next_text: 'undefined' !== typeof et_pb_custom ? et_pb_custom.next : '', // next arrow text
            swipe_text:
              'undefined' !== typeof et_pb_custom && et_pb_custom.slider_swipe ? et_pb_custom.slider_swipe : 'SWIPE →', // bottom controls swipe label
            show_bottom_controls_counter: true,
            show_bottom_controls_swipe: true,
            fade_speed: 500, // fade effect speed
            use_arrows: true, // use arrows?
            use_controls: true, // use controls?
            manual_arrows: '', // html code for custom arrows
            append_controls_to: '', // controls are appended to the slider element by default, here you can specify the element it should append to
            controls_below: false,
            controls_class: 'et-pb-controllers', // controls container class name
            slideshow: false, // automattic animation?
            slideshow_speed: 7000, // automattic animation speed
            show_progress_bar: false, // show progress bar if automattic animation is active
            tabs_animation: false,
            use_carousel: false,
            active_slide: 0,
          },
          options,
        );

        const $et_slider = $(el);
        let $et_slide = $et_slider.closest_descendent(settings.slide);
        const et_slides_number = $et_slide.length;
        const et_fade_speed = settings.fade_speed;
        let et_active_slide = settings.active_slide;
        let $et_slider_arrows;
        let $et_slider_prev;
        let $et_slider_next;
        let $et_slider_controls;
        let $et_slider_carousel_controls;
        let et_slider_timer;
        let controls_html = '';
        let carousel_html = '';
        const $progress_bar = null;
        const progress_timer_count = 0;
        const $et_pb_container = $et_slider.find('.et_pb_container');
        const et_pb_container_width = $et_pb_container.width();
        const is_post_slider = $et_slider.hasClass('et_pb_post_slider');
        const is_slider_bottom_controls = $et_slider.hasClass('et_pb_slider_bottom_controls');
        const et_slider_breakpoint = '';
        let stop_slider = false;
        let $et_slider_bottom_controls;
        let $et_slider_bottom_controls_current;

        $et_slider.et_animation_running = false;

        $.data(el, 'et_pb_simple_slider', $et_slider);

        $et_slide.eq(0).addClass('et-pb-active-slide');

        $et_slider.attr('data-active-slide', $et_slide.data('slide-id'));

        if (!settings.tabs_animation) {
          if (
            !$et_slider.hasClass('et_pb_bg_layout_dark') &&
            !$et_slider.hasClass('et_pb_bg_layout_light') &&
            !$et_slider.hasClass('et_pb_slider_empty')
          ) {
            $et_slider.addClass(et_get_bg_layout_color($et_slide.eq(0)));
          }
        }
        if (settings.use_arrows && et_slides_number > 1) {
          if ('' == settings.manual_arrows) {
            // Setting style="color:inherit" for Gallery Slider's arrows
            if (settings.hasOwnProperty('slide') && '.et_pb_gallery_item' === settings.slide) {
              $et_slider.append(
                `${'<div class="et-pb-slider-arrows"><a class="et-pb-arrow-prev" href="#" style="color:inherit">' + '<span>'}${settings.previous_text}</span>` +
                  '</a><a class="et-pb-arrow-next" href="#" style="color:inherit">' +
                  `<span>${settings.next_text}</span>` +
                  '</a></div>',
              );
            } else {
              $et_slider.append(
                `${'<div class="et-pb-slider-arrows"><a class="et-pb-arrow-prev" href="#" >' + '<span>'}${settings.previous_text}</span>` +
                  '</a><a class="et-pb-arrow-next" href="#">' +
                  `<span>${settings.next_text}</span>` +
                  '</a></div>',
              );
            }
          } else {
            $et_slider.append(settings.manual_arrows);
          }

          $et_slider_arrows = $et_slider.find(settings.arrows);
          $et_slider_prev = $et_slider.find(settings.prev_arrow);
          $et_slider_next = $et_slider.find(settings.next_arrow);

          $et_slider.on('click.et_pb_simple_slider', settings.next_arrow, () => {
            if ($et_slider.et_animation_running) return false;

            $et_slider.et_slider_move_to('next');

            return false;
          });

          $et_slider.on('click.et_pb_simple_slider', settings.prev_arrow, () => {
            if ($et_slider.et_animation_running) return false;

            $et_slider.et_slider_move_to('previous');

            return false;
          });

          // swipe support requires et-jquery-touch-mobile
          $et_slider.on('swipeleft.et_pb_simple_slider', settings.slide, event => {
            // do not switch slide on selecting text in VB
            if (
              $(event.target).closest('.et-fb-popover-tinymce').length ||
              $(event.target).closest('[data-et-vb-editable-element]').length
            ) {
              return;
            }

            $et_slider.et_slider_move_to('next');
          });
          $et_slider.on('swiperight.et_pb_simple_slider', settings.slide, event => {
            // do not switch slide on selecting text in VB
            if (
              $(event.target).closest('.et-fb-popover-tinymce').length ||
              $(event.target).closest('[data-et-vb-editable-element]').length
            ) {
              return;
            }

            $et_slider.et_slider_move_to('previous');
          });
        }

        if (settings.use_controls && et_slides_number > 1) {
          for (var i = 1; i <= et_slides_number; i++) {
            controls_html += `<a href="#"${1 == i ? ` class="${settings.control_active_class}"` : ''}>${i}</a>`;
          }

          if ($et_slider.find('video').length > 0) {
            settings.controls_class += ' et-pb-controllers-has-video-tag';
          }

          if (is_slider_bottom_controls) {
            // Isolate swipe progress from legacy .et-pb-controllers a / .et-pb-active-control color rules.
            settings.controls = '.et-pb-slider-bottom-controls-progress a';

            const counter_html =
              false !== settings.show_bottom_controls_counter
                ? [
                    '<span class="et-pb-slider-bottom-controls-counter" aria-live="polite">',
                    `<span class="et-pb-slider-bottom-controls-current">${et_format_slider_count(et_active_slide + 1)}</span>`,
                    ` / <span class="et-pb-slider-bottom-controls-total">${et_format_slider_count(et_slides_number)}</span>`,
                    '</span>',
                  ].join('')
                : '';

            controls_html = [
              '<div class="et-pb-slider-bottom-controls">',
              counter_html,
              `<div class="et-pb-slider-bottom-controls-progress">${controls_html}</div>`,
              '</div>',
            ].join('');
          } else {
            controls_html = `<div class="${settings.controls_class}">${controls_html}</div>`;
          }

          if ('' == settings.append_controls_to) $et_slider.append(controls_html);
          else $(settings.append_controls_to).append(controls_html);

          if (settings.controls_below) $et_slider_controls = $et_slider.parent().find(settings.controls);
          else $et_slider_controls = $et_slider.find(settings.controls);

          $et_slider_controls.on('click.et_pb_simple_slider', function () {
            if ($et_slider.et_animation_running) return false;

            $et_slider.et_slider_move_to($(this).index());

            return false;
          });

          if (is_slider_bottom_controls) {
            $et_slider_bottom_controls = $et_slider.find('.et-pb-slider-bottom-controls');
            $et_slider_bottom_controls_current = $et_slider_bottom_controls.find(
              '.et-pb-slider-bottom-controls-current',
            );

            if (false !== settings.show_bottom_controls_swipe) {
              // Build the swipe label with the DOM API and assign it as text, never HTML.
              const $swipe_label = $('<span>', { class: 'et-pb-slider-bottom-controls-swipe' });
              $swipe_label.text(et_as_plain_text(settings.swipe_text));
              $et_slider_bottom_controls.append($swipe_label);
            }

            if ('function' === typeof window.requestAnimationFrame) {
              window.requestAnimationFrame(() => {
                et_style_slider_bottom_controls();
                et_update_slider_bottom_controls_state();
              });
            } else {
              setTimeout(() => {
                et_style_slider_bottom_controls();
                et_update_slider_bottom_controls_state();
              }, 0);
            }
          }
        }

        if (settings.use_carousel && et_slides_number > 1) {
          // Build carousel container using DOM API for safe HTML construction.
          const $carousel = $('<div class="et_pb_carousel"><div class="et_pb_carousel_items"></div></div>');
          const $carousel_items = $carousel.find('.et_pb_carousel_items');

          for (var i = 1; i <= et_slides_number; i++) {
            const slide_id = i - 1;
            const image_src_raw = $et_slide.eq(slide_id).data('image');
            const image_src = typeof image_src_raw !== 'undefined' ? image_src_raw : '';

            // Build carousel item using DOM API to prevent XSS via style attribute injection.
            const $carousel_item = $(
              `<div class="et_pb_carousel_item_${slide_id} et_pb_carousel_item ${1 === i ? settings.control_active_class : ''}" data-slide-id="${slide_id}">` +
                '<div class="et_pb_video_overlay" href="#">' +
                '<div class="et_pb_video_overlay_hover"><a href="#" class="et_pb_video_play"></a></div>' +
                '</div>' +
                '</div>',
            );

            // Safely set background-image via CSS API to prevent attribute-breakout XSS.
            if (image_src) {
              $carousel_item.find('.et_pb_video_overlay').css('background-image', `url(${image_src})`);
            }

            $carousel_item.appendTo($carousel_items);
          }

          $et_slider.after($carousel);

          $et_slider_carousel_controls = $et_slider.siblings('.et_pb_carousel').find(settings.carousel_controls);
          $et_slider_carousel_controls.on('click.et_pb_simple_slider', function () {
            if ($et_slider.et_animation_running) return false;

            const $this = $(this);
            $et_slider.et_slider_move_to($this.data('slide-id'));

            return false;
          });

          // Notify the video slider carousel script to initialize the newly built carousel.
          // The carousel DOM is built here (for both above-the-fold init and below-the-fold
          // lazy init via IntersectionObserver), so the carousel script can hook in
          // regardless of script load order or lazy-loading timing.
          $(document).trigger('et_pb_video_slider_carousel_created', [$carousel]);
        }

        if (settings.slideshow && et_slides_number > 1) {
          $et_slider
            .on('mouseenter.et_pb_simple_slider', () => {
              if ($et_slider.hasClass('et_slider_auto_ignore_hover')) {
                return;
              }

              $et_slider.addClass('et_slider_hovered');

              if (typeof et_slider_timer !== 'undefined') {
                clearTimeout(et_slider_timer);
              }
            })
            .on('mouseleave.et_pb_simple_slider', () => {
              if ($et_slider.hasClass('et_slider_auto_ignore_hover')) {
                return;
              }

              $et_slider.removeClass('et_slider_hovered');

              et_slider_auto_rotate();
            });
        }

        et_slider_auto_rotate();

        function et_slider_auto_rotate() {
          if (stop_slider) {
            return;
          }

          // Slider animation can be dynamically paused with et_pb_pause_slider
          // Make sure animation will start when class is removed by checking clas existence every 2 seconds.
          if ($et_slider.hasClass('et_pb_pause_slider')) {
            setTimeout(() => {
              et_slider_auto_rotate();
            }, 2000);

            return;
          }

          if (settings.slideshow && et_slides_number > 1 && !$et_slider.hasClass('et_slider_hovered')) {
            et_slider_timer = setTimeout(() => {
              $et_slider.et_slider_move_to('next');
            }, settings.slideshow_speed);
          }
        }

        function et_format_slider_count(slide_position) {
          return `${slide_position}`.padStart(2, '0');
        }

        function et_style_slider_bottom_controls() {
          if (!is_slider_bottom_controls || !$et_slider_bottom_controls || 0 === $et_slider_bottom_controls.length) {
            return;
          }
          et_ensure_slider_bottom_controls_styles();
        }

        function et_update_slider_bottom_controls_state() {
          if (
            !is_slider_bottom_controls ||
            !$et_slider_bottom_controls_current ||
            0 === $et_slider_bottom_controls_current.length
          ) {
            return;
          }

          $et_slider_bottom_controls_current.text(et_format_slider_count(et_active_slide + 1));
        }

        $et_slider.et_slider_destroy = function () {
          // Clear existing timer / auto rotate
          if (typeof et_slider_timer !== 'undefined') {
            clearTimeout(et_slider_timer);
          }

          stop_slider = true;

          // Deregister all own existing events
          $et_slider.off('.et_pb_simple_slider');

          // Removing existing style from slide(s)
          $et_slider.find('.et_pb_slide').css({
            'z-index': '',
            display: '',
            opacity: '',
          });

          // Removing existing classnames from slide(s)
          $et_slider.find('.et-pb-active-slide').removeClass('et-pb-active-slide');
          $et_slider.find('.et-pb-moved-slide').removeClass('et-pb-moved-slide');

          // Removing DOM that was added by slider
          $et_slider.find('.et-pb-slider-arrows, .et-pb-controllers, .et-pb-slider-bottom-controls').remove();
          $et_slider.siblings('.et_pb_carousel, .et-pb-controllers').remove();

          // Remove references
          $et_slider.removeData('et_pb_simple_slider');
        };

        function et_stop_video(active_slide) {
          let $et_video;
          let et_video_src;
          let video_timeout;

          // if there is a video in the slide, stop it when switching to another slide
          if (active_slide.has('iframe').length) {
            $et_video = active_slide.find('iframe');
            et_video_src = $et_video.attr('src');

            clearTimeout(video_timeout);
            $et_video.attr('src', '');
            video_timeout = setTimeout(() => {
              $et_video.attr('src', et_video_src);
            }, 100);
          } else if (active_slide.has('video').length) {
            if (!active_slide.find('.et-pb-background-video').length) {
              $et_video = active_slide.find('video');
              $et_video[0].pause();
            }
          }
        }

        // Remove inline width and height added by mediaelement.js
        function et_fix_slide_video_height() {
          const $this_slider = $et_slider;
          const $slide_video_container = $this_slider.find('.et-pb-active-slide .et_pb_slide_video');
          const slide_video_container_height = parseFloat($slide_video_container.height());
          const slide_wp_video_shortcode = $this_slider.find('.et_pb_slide_video .wp-video-shortcode');

          slide_wp_video_shortcode.css({
            width: '',
            height: '',
          });

          if (!isNaN(slide_video_container_height)) {
            $slide_video_container.css('marginTop', `-${slide_video_container_height / 2}px`);
          }
        }

        /**
         * Adjust slider controls (arrows and dots) position based on active slide's image dimensions.
         * This ensures controls are properly positioned relative to the active image, not just the slider container.
         *
         * @since ??
         */
        function et_fix_gallery_slider_controls_position() {
          // Only apply to gallery sliders.
          // Check the slider itself and its parent for gallery classes.
          const is_gallery =
            $et_slider.hasClass('et_pb_gallery') ||
            $et_slider.hasClass('et_pb_wc_gallery') ||
            $et_slider.parent().hasClass('et_pb_wc_gallery') ||
            $et_slider.closest('.et_pb_gallery').length > 0 ||
            $et_slider.closest('.et_pb_wc_gallery').length > 0;

          if (!is_gallery) {
            return;
          }

          // Re-fetch arrows and controls in case they weren't created when function was defined.
          const $arrows_container = $et_slider.find(settings.arrows);
          const $prev_arrow = $et_slider.find(settings.prev_arrow);
          const $next_arrow = $et_slider.find(settings.next_arrow);
          // Controls container is the parent of the control links.
          const $controls = $et_slider.find(
            settings.controls_class ? `.${settings.controls_class}` : '.et-pb-controllers',
          );

          // If arrows/controls don't exist yet, try again after a short delay.
          if (
            (settings.use_arrows && (!$arrows_container.length || !$prev_arrow.length || !$next_arrow.length)) ||
            (settings.use_controls && !$controls.length)
          ) {
            setTimeout(() => {
              et_fix_gallery_slider_controls_position();
            }, 100);
            return;
          }

          const $active_slide = $et_slider.find('.et-pb-active-slide');
          if (!$active_slide.length) {
            return;
          }

          // Find the image within the active slide.
          // For gallery sliders, images are in .et_pb_gallery_image > (a|.woocommerce-product-gallery__image) > img.
          // WooCommerce Product Gallery may have additional wrapper divs.
          const $gallery_image = $active_slide.find('.et_pb_gallery_image');
          const $image = $gallery_image.find('img').first();

          if (!$image.length) {
            // Reset to default positioning if no image found.
            if ($prev_arrow.length) {
              $prev_arrow.css('top', '');
            }
            if ($next_arrow.length) {
              $next_arrow.css('top', '');
            }
            if ($controls.length) {
              $controls.css('bottom', '');
            }
            return;
          }

          // Wait for image to load if it hasn't loaded yet.
          if (!$image[0].complete || 0 === $image[0].naturalHeight) {
            $image.on('load.et_gallery_controls', function () {
              et_fix_gallery_slider_controls_position();
              $image.off('load.et_gallery_controls');
            });
            return;
          }

          // Use requestAnimationFrame to ensure layout is complete.
          requestAnimationFrame(() => {
            // Get image position and dimensions relative to slider.
            const slider_offset = $et_slider.offset();
            const image_offset = $image.offset();
            const slider_height = $et_slider.innerHeight();
            const image_height = $image.outerHeight();

            if (!slider_offset || !image_offset || !slider_height || !image_height) {
              return;
            }

            const image_top = image_offset.top - slider_offset.top;
            const image_bottom = image_top + image_height;

            // Calculate arrow position: center of the image.
            const arrow_top = image_top + image_height / 2;

            // Calculate dots position: bottom of the image with 20px padding.
            const dots_bottom = slider_height - image_bottom + 20;

            // Apply positions to arrows.
            if (settings.use_arrows && $prev_arrow.length && $next_arrow.length) {
              // Convert to percentage for responsive behavior, but ensure it's within slider bounds.
              const arrow_top_percent = (arrow_top / slider_height) * 100;
              const clamped_arrow_top = Math.max(10, Math.min(90, arrow_top_percent));

              $prev_arrow.css({
                top: `${clamped_arrow_top}%`,
                marginTop: '-24px',
              });
              $next_arrow.css({
                top: `${clamped_arrow_top}%`,
                marginTop: '-24px',
              });
            }

            // Apply position to dots.
            if (settings.use_controls && $controls.length) {
              // Ensure dots are at least 20px from bottom, but adjust if image is smaller.
              const final_dots_bottom = Math.max(20, dots_bottom);
              $controls.css('bottom', `${final_dots_bottom}px`);
            }
          });
        }

        // Expose the function on the slider instance so it can be called from outside.
        $et_slider.et_fix_gallery_slider_controls_position = et_fix_gallery_slider_controls_position;

        $et_slider.et_fix_slider_content_images = et_fix_slider_content_images;

        function et_fix_slider_content_images() {
          const $this_slider = $et_slider;
          const $slide_image_container = $this_slider.find('.et-pb-active-slide .et_pb_slide_image');
          const $slide_image = $slide_image_container.find('img');
          const $slide_video_container = $this_slider.find('.et-pb-active-slide .et_pb_slide_video');
          const $slide = $slide_image_container.closest('.et_pb_slide');
          const $slider = $slide.closest('.et_pb_slider');
          const slide_height = parseFloat($slider.innerHeight());
          const image_height = parseFloat(slide_height * 0.8);
          let slide_image_container_height = parseFloat($slide_image_container.height());
          const slide_video_container_height = parseFloat($slide_video_container.height());
          const $et_pb_first_row_first_module = et_get_first_section().children('.et_pb_module:visible').first();
          const $et_pb_first_row_first_module_slide_container = $et_pb_first_row_first_module.find(
            '.et_pb_slide .et_pb_container',
          );
          const $is_pb_fullwidth_section_first = et_get_first_section().is('.et_pb_fullwidth_section');
          let slide_image_container_height_1st_row_1st_module = parseFloat(
            $et_pb_first_row_first_module_slide_container.height(),
          );
          const image_height_1st_row_1st_module = parseFloat(slide_image_container_height_1st_row_1st_module * 0.8);

          if (!isNaN(image_height)) {
            $slide_image_container.find('img').css('maxHeight', `${image_height}px`);

            slide_image_container_height = parseInt($slide_image_container.height());

            if (
              window.et_is_transparent_nav &&
              $et_pb_first_row_first_module.is('.et_pb_slider') &&
              $is_pb_fullwidth_section_first
            ) {
              $slide_image_container.find('img').css('maxHeight', `${image_height_1st_row_1st_module}px`);
              slide_image_container_height = parseInt($slide_image_container.height());
            }
          }

          if (!isNaN(slide_image_container_height) && $slide.hasClass('et_pb_media_alignment_center')) {
            $slide_image_container.css('marginTop', `-${slide_image_container_height / 2}px`);

            // Add load jQuery event only once.
            if (!$slide_image.data('hasLoadEvent')) {
              $slide_image.data('hasLoadEvent', true);

              // It will fix the image position when lazy loading image is enabled.
              $slide_image.on('load', () => {
                slide_image_container_height = parseFloat($slide_image_container.height());
                $slide_image_container.css('marginTop', `-${slide_image_container_height / 2}px`);
              });
            }
          }

          if (!isNaN(slide_video_container_height)) {
            $slide_video_container.css('marginTop', `-${slide_video_container_height / 2}px`);
          }

          // Adjust gallery slider controls position after fixing content images.
          // Use a delay to ensure image dimensions are calculated.
          setTimeout(() => {
            et_fix_gallery_slider_controls_position();
          }, 150);
        }

        function et_reinit_fullwidth_portfolio($container) {
          if ('function' !== typeof window.set_fullwidth_portfolio_columns) {
            return;
          }

          const $fullwidthPortfolios = $container.find('.et_pb_fullwidth_portfolio:visible');

          if (0 === $fullwidthPortfolios.length) {
            return;
          }

          $fullwidthPortfolios.each((index, element) => {
            const $portfolio = $(element);
            const isCarousel = $portfolio.hasClass('et_pb_fullwidth_portfolio_carousel');
            window.set_fullwidth_portfolio_columns($portfolio, isCarousel);
          });
        }

        function et_has_slide_parallax($slide) {
          return (
            $slide?.hasClass('et_pb_section_parallax') ||
            $slide?.find('.et_parallax_bg, [class*="et-pb-parallax-background-module--"]').length > 0
          );
        }

        function et_reinit_background_parallax($slide) {
          if (!et_has_slide_parallax($slide) || !('diviElementBackgroundParallaxInit' in window)) {
            return;
          }

          const allParallaxData = window.diviElementBackgroundParallaxData;
          const slideParallaxData = Array.isArray(allParallaxData)
            ? allParallaxData
                .map(({ selector, data }) => ({
                  selector,
                  data: data.filter(({ uniqueSelector }) => $slide.find(uniqueSelector).length > 0),
                }))
                .filter(({ data }) => data.length > 0)
            : [];

          // Re-init after next slide is display:block but still opacity:0.
          // Re-init only the incoming slide's parallax data to avoid affecting outgoing slide
          // transforms during the cross-fade.
          requestAnimationFrame(() => {
            if (slideParallaxData.length > 0) {
              window.diviElementBackgroundParallaxInit(slideParallaxData);
            }
          });
        }

        function et_get_bg_layout_color($slide) {
          // Check if there are results - if div.entry exists, return empty string to avoid white-on-white text
          if ($('div.entry').length) {
            return '';
          }

          if ($slide.hasClass('et_pb_bg_layout_light')) {
            return 'et_pb_bg_layout_light';
          }

          return 'et_pb_bg_layout_dark';
        }

        // fix the appearance of some modules inside the post slider
        function et_fix_builder_content() {
          if (is_post_slider) {
            setTimeout(() => {
              const $et_pb_number_counter = $('.et_pb_number_counter');

              if (typeof window.et_fix_testimonial_inner_width === 'function') {
                window.et_fix_testimonial_inner_width();
              }

              if ('diviModuleCircleCounterReinit' in window) {
                window.diviModuleCircleCounterReinit();
              }

              if ('diviModuleNumberCounterReinit' in window) {
                window.diviModuleNumberCounterReinit();
              }
              window.et_reinit_waypoint_modules();
            }, 1000);
          }
        }

        if (window.et_load_event_fired) {
          'function' === typeof et_fix_slider_height && et_fix_slider_height($et_slider);
          // Adjust gallery slider controls position on initial load.
          et_fix_gallery_slider_controls_position();
        } else {
          $et_window.on('load', () => {
            'function' === typeof et_fix_slider_height && et_fix_slider_height($et_slider);
            // Adjust gallery slider controls position on initial load.
            et_fix_gallery_slider_controls_position();
          });
        }

        $et_window.on('resize.et_simple_slider', () => {
          et_fix_slider_height($et_slider);
          // Adjust gallery slider controls position on window resize.
          et_fix_gallery_slider_controls_position();
        });

        // For gallery sliders, also listen for image load events to reposition controls when lazy-loaded images finish loading.
        // This is especially important on frontend where images may load after the initial page load.
        const is_gallery_slider_for_listener =
          $et_slider.hasClass('et_pb_gallery') || $et_slider.hasClass('et_pb_wc_gallery');
        if (is_gallery_slider_for_listener) {
          $et_slider.find('.et_pb_gallery_image img').on('load.et_gallery_slider_lazy', function () {
            // Only trigger if this image is in the active slide.
            const $img = $(this);
            if ($img.closest('.et-pb-active-slide').length > 0) {
              et_fix_gallery_slider_controls_position();
            }
            // Remove listener after first load to prevent memory leaks.
            $img.off('load.et_gallery_slider_lazy');
          });
        }

        $et_slider.et_slider_move_to = function (direction) {
          $et_slide = $et_slider.closest_descendent(settings.slide);
          const $active_slide = $et_slide.eq(et_active_slide);

          $et_slider.et_animation_running = true;

          $et_slider
            .removeClass('et_slide_transition_to_next et_slide_transition_to_previous')
            .addClass(`et_slide_transition_to_${direction}`);

          $et_slider.find('.et-pb-moved-slide').removeClass('et-pb-moved-slide');

          if ('next' === direction || 'previous' === direction) {
            if ('next' === direction) {
              et_active_slide = et_active_slide + 1 < et_slides_number ? et_active_slide + 1 : 0;
            } else {
              et_active_slide = et_active_slide - 1 >= 0 ? et_active_slide - 1 : et_slides_number - 1;
            }
          } else {
            if (et_active_slide === direction) {
              // When video is added, slider needs to be reloaded, so inline styles need to be added again
              $et_slider.find('.et-pb-inactive-slide').css({
                'z-index': '',
                display: '',
                opacity: 0,
              });
              $active_slide
                .css({
                  display: 'block',
                  opacity: 1,
                })
                .data('slide-status', 'active');
              et_update_slider_bottom_controls_state();
              $et_slider.et_animation_running = false;
              return;
            }

            et_active_slide = direction;
          }

          $et_slider.attr('data-active-slide', $et_slide.eq(et_active_slide).data('slide-id'));

          if (typeof et_slider_timer !== 'undefined') {
            clearTimeout(et_slider_timer);
          }

          const $next_slide = $et_slide.eq(et_active_slide);

          $et_slider.trigger('slide', {
            current: $active_slide,
            next: $next_slide,
          });

          if (
            typeof $active_slide.find('video')[0] !== 'undefined' &&
            typeof $active_slide.find('video')[0].player !== 'undefined'
          ) {
            $active_slide.find('video')[0].player.pause();
          }

          if (
            typeof $next_slide.find('video')[0] !== 'undefined' &&
            typeof $next_slide.find('video')[0].player !== 'undefined'
          ) {
            $next_slide.find('video')[0].player.play();
          }

          const $active_slide_video = $active_slide.find('.et_pb_video_box iframe');

          if ($active_slide_video.length) {
            let active_slide_video_src = $active_slide_video.attr('src');

            // Removes the "autoplay=1" parameter when switching slides
            // by covering three possible cases:

            // "?autoplay=1" at the end of the URL
            active_slide_video_src = active_slide_video_src.replace(/\?autoplay=1$/, '');

            // "?autoplay=1" followed by another parameter
            active_slide_video_src = active_slide_video_src.replace(/\?autoplay=1&(amp;)?/, '?');

            // "&autoplay=1" anywhere in the URL
            active_slide_video_src = active_slide_video_src.replace(/&(amp;)?autoplay=1/, '');

            // Delays the URL update so that the cross-fade animation's smoothness is not affected
            setTimeout(() => {
              $active_slide_video.attr({
                src: active_slide_video_src,
              });
            }, settings.fade_speed);

            // Restores video overlay
            $active_slide_video.parents('.et_pb_video_box').next('.et_pb_video_overlay').css({
              display: 'block',
              opacity: 1,
            });
          }

          $et_slider.trigger('simple_slider_before_move_to', {
            direction,
            next_slide: $next_slide,
          });

          $et_slide.each(function () {
            $(this).css('zIndex', 1);
          });

          // add 'slide-status' data attribute so it can be used to determine active slide in Visual Builder
          $active_slide
            .css('zIndex', 2)
            .removeClass('et-pb-active-slide')
            .addClass('et-pb-moved-slide')
            .data('slide-status', 'inactive');
          $next_slide
            .css({
              display: 'block',
              opacity: 0,
            })
            .addClass('et-pb-active-slide')
            .data('slide-status', 'active');

          et_fix_slide_video_height();
          et_fix_slider_content_images();
          et_fix_builder_content();

          // Adjust gallery slider controls position after slide change starts.
          setTimeout(() => {
            et_fix_gallery_slider_controls_position();
          }, 50);

          // When there is no control on single slide, $et_slider_controls is undefined.
          // So, we need to check if it is defined before remove or add class.
          if (settings.use_controls && $et_slider_controls)
            $et_slider_controls
              .removeClass(settings.control_active_class)
              .eq(et_active_slide)
              .addClass(settings.control_active_class);

          if (settings.use_carousel && $et_slider_carousel_controls)
            $et_slider_carousel_controls
              .removeClass(settings.control_active_class)
              .eq(et_active_slide)
              .addClass(settings.control_active_class);

          et_update_slider_bottom_controls_state();

          if (!settings.tabs_animation) {
            et_reinit_background_parallax($next_slide);

            $next_slide.animate(
              {
                opacity: 1,
              },
              et_fade_speed,
              function () {
                // Wait for fade-complete so nested roll/entrance animations are not played while the slide is still opacity 0.
                if (!isBuilder) {
                  triggerDestinationSlideAnimations($next_slide);
                }
              },
            );
            $active_slide
              .addClass('et_slide_transition')
              .css({
                display: 'list-item',
                opacity: 1,
              })
              .animate(
                {
                  opacity: 0,
                },
                et_fade_speed,
                function () {
                  const active_slide_layout_bg_color = et_get_bg_layout_color($active_slide);
                  const next_slide_layout_bg_color = et_get_bg_layout_color($next_slide);

                  // Builder dynamically updates the slider options, so no need to set `display: none;` because it creates unwanted visual effects.
                  if (isBuilder) {
                    $(this).removeClass('et_slide_transition');
                  } else {
                    $(this).css('display', 'none').removeClass('et_slide_transition');
                  }

                  et_stop_video($active_slide);

                  $et_slider.removeClass(active_slide_layout_bg_color).addClass(next_slide_layout_bg_color);

                  $et_slider.et_animation_running = false;

                  if ($et_slider.hasClass('et_pb_gallery') && 'none' === $next_slide.css('maxHeight')) {
                    // Add a max-height to active slider to fix content jumping issue in Webkit browsers.
                    // @see https://github.com/elegantthemes/Divi/issues/25001
                    $next_slide.css('maxHeight', $next_slide.outerHeight());
                  }

                  // Adjust gallery slider controls position after slide transition completes.
                  // Use a delay to ensure layout is fully complete.
                  setTimeout(() => {
                    et_fix_gallery_slider_controls_position();
                  }, 100);

                  $et_slider.trigger('simple_slider_after_move_to', {
                    next_slide: $next_slide,
                  });
                  et_reinit_fullwidth_portfolio($next_slide);

                  // Restart autoplay timer after animation completes to ensure consistent timing.
                  et_slider_auto_rotate();
                },
              );
          } else {
            $next_slide.css({
              display: 'none',
              opacity: 0,
            });

            $active_slide
              .addClass('et_slide_transition')
              .css({
                display: 'block',
                opacity: 1,
              })
              .animate(
                {
                  opacity: 0,
                },
                et_fade_speed,
                function () {
                  $(this).css('display', 'none').removeClass('et_slide_transition');

                  $next_slide
                    .css({
                      display: 'block',
                      opacity: 0,
                    })
                    .promise()
                    .done(() => {
                      et_reinit_background_parallax($next_slide);

                      $next_slide.animate(
                        {
                          opacity: 1,
                        },
                        et_fade_speed,
                        () => {
                          // Wait for fade-complete so nested roll/entrance animations are not played while the slide is still opacity 0.
                          if (!isBuilder) {
                            triggerDestinationSlideAnimations($next_slide);
                          }

                          $et_slider.et_animation_running = false;

                          // Adjust gallery slider controls position after slide transition completes.
                          et_fix_gallery_slider_controls_position();

                          $et_slider.trigger('simple_slider_after_move_to', {
                            next_slide: $next_slide,
                          });
                          $(window).trigger('resize');
                          et_reinit_fullwidth_portfolio($next_slide);

                          // Restart autoplay timer after animation completes to ensure consistent timing.
                          et_slider_auto_rotate();
                        },
                      );
                    });
                },
              );
          }
        };
      };

      $.fn.et_pb_simple_slider = function (options) {
        return this.each(function () {
          const slider = $.data(this, 'et_pb_simple_slider');
          return slider || new $.et_pb_simple_slider(this, options);
        });
      };

      // Document Ready
      $(() => {
        const debounced_et_fix_slider_height = {};

        window.et_pb_slider_init = function ($this_slider) {
          const et_slider_settings = {
            fade_speed: 700,
            slide: !$this_slider.hasClass('et_pb_gallery') ? '.et_pb_slide' : '.et_pb_gallery_item',
          };

          if ($this_slider.hasClass('et_pb_slider_no_arrows')) et_slider_settings.use_arrows = false;

          if ($this_slider.hasClass('et_pb_slider_no_pagination')) et_slider_settings.use_controls = false;

          if ($this_slider.hasClass('et_slider_auto')) {
            const et_slider_autospeed_class_value = /et_slider_speed_(\d+)/g;

            et_slider_settings.slideshow = true;

            const et_slider_autospeed = et_slider_autospeed_class_value.exec($this_slider.attr('class'));

            et_slider_settings.slideshow_speed = null === et_slider_autospeed ? 10 : et_slider_autospeed[1];
          }

          if ($this_slider.parent().hasClass('et_pb_video_slider')) {
            et_slider_settings.controls_below = true;
            et_slider_settings.append_controls_to = $this_slider.parent();

            setTimeout(() => {
              $('.et_pb_preload').removeClass('et_pb_preload');
            }, 500);
          }

          if ($this_slider.hasClass('et_pb_slider_carousel')) et_slider_settings.use_carousel = true;

          if ($this_slider.hasClass('et_pb_slider_bottom_controls')) {
            const swipe_text = et_get_plain_text_attr($this_slider, 'data-swipe-text');

            if ('' !== swipe_text) {
              et_slider_settings.swipe_text = swipe_text;
            }

            if ('off' === $this_slider.attr('data-show-counter')) {
              et_slider_settings.show_bottom_controls_counter = false;
            }

            if ('off' === $this_slider.attr('data-show-swipe-label')) {
              et_slider_settings.show_bottom_controls_swipe = false;
            }
          }

          $this_slider.et_pb_simple_slider(et_slider_settings);

          // Adjust gallery slider controls position after initialization.
          if ($this_slider.hasClass('et_pb_gallery') || $this_slider.hasClass('et_pb_wc_gallery')) {
            setTimeout(() => {
              const $slider_instance = $this_slider.data('et_pb_simple_slider');
              if ($slider_instance && typeof $slider_instance.et_fix_gallery_slider_controls_position === 'function') {
                $slider_instance.et_fix_gallery_slider_controls_position();
              }
            }, 300);
          }
        };

        if ($et_pb_slider.length) {
          if (
            isBuilder ||
            typeof IntersectionObserver === 'undefined' ||
            !window?.diviSliderLazyLoadData ||
            Object.keys(window?.diviSliderLazyLoadData || {}).length === 0
          ) {
            // isBuilder or IntersectionObserver not supported or no script data - fallback to "safe" behavior and initialize all available sliders immediately.
            $et_pb_slider.each(function () {
              const $this_slider = $(this);
              et_pb_slider_init($this_slider);
            });
          } else {
            const aboveFoldModuleSelectors = [];
            const belowFoldModuleSelectors = [];
            const scriptData = window?.diviSliderLazyLoadData || {};

            Object.values(scriptData).forEach(value => {
              if (value.is_above_the_fold) {
                aboveFoldModuleSelectors.push(value.selector);
              } else {
                belowFoldModuleSelectors.push(value.selector);
              }
            });

            // Module selectors target the module wrapper. For a regular Slider module the
            // wrapper itself carries the `.et_pb_slider` class, but for a Video Slider the
            // `.et_pb_slider` is a child of the wrapper. Resolve down to the actual
            // `.et_pb_slider` element(s) so class detection (carousel/pagination/arrows)
            // works correctly for both module types.
            const resolveSliders = $modules => $modules.find('.et_pb_slider').addBack('.et_pb_slider');

            // Initialize all above-the-fold sliders immediately. This must always run,
            // even when below-the-fold sliders also exist, otherwise above-the-fold
            // sliders are never initialized.
            resolveSliders($(aboveFoldModuleSelectors.join(', '))).each(function () {
              et_pb_slider_init($(this));
            });

            // Handle all the below-the-fold sliders with deferred loading via IntersectionObserver.
            if (belowFoldModuleSelectors.length > 0 && typeof IntersectionObserver !== 'undefined') {
              // Use IntersectionObserver for the below-the-fold sliders.
              const observerOptions = {
                root: null,
                rootMargin: '50px',
                threshold: 0.01,
              };

              const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    const moduleElement = entry.target;
                    // Resolve to the actual `.et_pb_slider` element within the module
                    // (or the module itself for regular sliders) before initializing.
                    resolveSliders($(moduleElement)).each(function () {
                      et_pb_slider_init($(this));
                    });
                    observer.unobserve(moduleElement);
                  }
                });
              }, observerOptions);

              $(belowFoldModuleSelectors.join(', ')).each(function () {
                observer.observe(this);
              });
            }

            // Selective init only covers modules registered in diviSliderLazyLoadData.
            // Other .et_pb_slider implementations (e.g. fullwidth Gallery) still need the
            // shared runtime when lazy-load data is present on the page. Skip registered
            // modules (including below-the-fold deferred ones) so IntersectionObserver deferral
            // is preserved; only unregistered .et_pb_slider elements fall through to eager init.
            const registeredModuleSelectors = Object.values(scriptData)
              .map(value => value.selector)
              .filter(Boolean);

            const isRegisteredSlider = $slider =>
              registeredModuleSelectors.some(selector => $slider.is(selector) || $slider.closest(selector).length > 0);

            $et_pb_slider
              .filter(function () {
                const $this_slider = $(this);

                return !$.data(this, 'et_pb_simple_slider') && !isRegisteredSlider($this_slider);
              })
              .each(function () {
                et_pb_slider_init($(this));
              });
          }
        }

        // This function can end up being called a lot of times and it's quite expensive in terms of cpu due to
        // recalculating styles. Debouncing it (VB only) for performances reasons.
        window.et_fix_slider_height = !isBuilder
          ? et_fix_slider_height
          : function ($slider) {
              const $this_slider = $slider || $et_pb_slider;

              if (!$this_slider || !$this_slider.length) {
                return;
              }

              // Create a debounced function per slider
              const address = $this_slider.data('address');
              if (!debounced_et_fix_slider_height[address]) {
                debounced_et_fix_slider_height[address] = window.et_pb_debounce(et_fix_slider_height, 100);
              }
              debounced_et_fix_slider_height[address]($slider);
            };
      });

      const et_fix_slider_height = $slider => {
        const $this_slider = $slider || $et_pb_slider;

        if (!$this_slider || !$this_slider.length) {
          return;
        }

        $this_slider.each(function () {
          const $current_slider = $(this);
          // Check both the slider element and its closest parent for gallery classes.
          // Gallery classes may be on the slider itself or on a parent wrapper.
          let is_gallery_slider =
            $current_slider.hasClass('et_pb_gallery') ||
            $current_slider.hasClass('et_pb_wc_gallery') ||
            $current_slider.closest('.et_pb_gallery, .et_pb_wc_gallery').length > 0;
          const $slide_section = $current_slider.parent('.et_pb_section');
          let $slides = $current_slider.find(is_gallery_slider ? '.et_pb_gallery_item' : '.et_pb_slide');

          // Fallback: If no slides found with regular selector, try gallery selector.
          // This handles cases where gallery detection might have failed.
          if (0 === $slides.length && !is_gallery_slider) {
            $slides = $current_slider.find('.et_pb_gallery_item');
            if ($slides.length > 0) {
              is_gallery_slider = true;
            }
          }

          const $slide_containers = $slides.find('.et_pb_container');
          let max_height = 0;
          let image_margin = 0;
          const need_image_margin_top = $current_slider.hasClass('et_pb_post_slider_image_top');
          const need_image_margin_bottom = $current_slider.hasClass('et_pb_post_slider_image_bottom');

          // If this is appears at the first section beneath transparent nav, skip it
          // leave it to et_fix_page_container_position()
          if ($slide_section.is('.et_pb_section_first')) {
            return true;
          }

          // Gallery sliders don't have containers, so skip container-specific logic.
          if (!is_gallery_slider) {
            $slide_containers.css('height', '');
          }

          // make slides visible to calculate the height correctly
          $slides.addClass('et_pb_temp_slide');

          // Fix slider content images (for regular sliders).
          // Note: et_fix_slider_content_images already calls et_fix_gallery_slider_controls_position for gallery sliders.
          if ('object' === typeof $current_slider.data('et_pb_simple_slider')) {
            $current_slider.data('et_pb_simple_slider').et_fix_slider_content_images();
          }

          $slides.each(function () {
            let height = parseFloat($(this).innerHeight());
            const $slide_image = is_gallery_slider
              ? $(this).find('.et_pb_gallery_image')
              : $(this).find('.et_pb_slide_image');
            const adjustedHeight = parseFloat($(this).data('adjustedHeight'));
            const autoTopPadding = isNaN(adjustedHeight) ? 0 : adjustedHeight;

            // reduce the height by autopadding value if slider height was adjusted. This is required in VB.
            height = autoTopPadding && autoTopPadding < height ? height - autoTopPadding : height;

            if (need_image_margin_top || need_image_margin_bottom) {
              if ($slide_image.length) {
                // get the margin from slides with image
                image_margin = need_image_margin_top
                  ? parseFloat($slide_image.css('margin-top'))
                  : parseFloat($slide_image.css('margin-bottom'));
                image_margin += 10;
              } else if (!is_gallery_slider) {
                // add class to slides without image to adjust their height accordingly
                // Gallery sliders don't have containers, so skip this.
                $(this).find('.et_pb_container').addClass('et_pb_no_image');
              }
            }

            // mark the slides without content
            // Gallery sliders don't have slide descriptions, so skip this check.
            if (!is_gallery_slider) {
              if (
                0 === $(this).find('.et_pb_slide_description').length ||
                0 === $(this).find('.et_pb_slide_description').html().trim().length
              ) {
                $(this).find('.et_pb_container').addClass('et_pb_empty_slide');
              }
            }

            if (max_height < height) {
              max_height = height;
            }
          });

          if (max_height + image_margin < 1) {
            // No slides have any content. It's probably being used with background images only.
            // Reset the height so that it falls back to the default padding for the content.
            if (!is_gallery_slider) {
              $slide_containers.css('height', '');
            }
          } else if (!is_gallery_slider) {
            // Gallery sliders don't have containers, so skip container height setting.
            $slide_containers.css('height', `${max_height + image_margin}px`);
          }

          // remove temp class after getting the slider height
          $slides.removeClass('et_pb_temp_slide');

          // Show the active slide's image (if exists)
          const $active_slide_image = is_gallery_slider
            ? $slides.filter('.et-pb-active-slide').find('.et_pb_gallery_image').children('img')
            : $slides.filter('.et-pb-active-slide').find('.et_pb_slide_image').children('img');
          $active_slide_image.addClass('active');

          // Adjust gallery slider controls position after fixing slider height.
          if (is_gallery_slider) {
            const $gallery_slider_instance = $current_slider.data('et_pb_simple_slider');
            if (
              $gallery_slider_instance &&
              typeof $gallery_slider_instance.et_fix_gallery_slider_controls_position === 'function'
            ) {
              setTimeout(() => {
                $gallery_slider_instance.et_fix_gallery_slider_controls_position();
              }, 100);
            }
          }
        });
      };

      function et_get_first_section() {
        return $('.et-l:not(.et-l--footer) .et_pb_section:visible').first();
      }

      $(window).resize(function () {
        et_fix_slider_height();
      });
    };

    window.et_pb_init_slider_modules();
  });
})(jQuery);
